import { ElementRef, EventEmitter } from '@angular/core';
import { UserContext } from '../../../auth/models/auth';
var UserMenuComponent = /** @class */ (function () {
    function UserMenuComponent(elemRef) {
        this.elemRef = elemRef;
        this.onSelectCustomer = new EventEmitter();
        this.showUserMenu = false;
    }
    UserMenuComponent.prototype.outSideClick = function (event, targetElement) {
        if (!targetElement) {
            return;
        }
        if (!this.elemRef.nativeElement.contains(targetElement))
            this.showUserMenu = false;
    };
    Object.defineProperty(UserMenuComponent.prototype, "fullname", {
        get: function () {
            return this.user && this.user.fullname;
        },
        enumerable: true,
        configurable: true
    });
    UserMenuComponent.prototype.selectCustomer = function () {
        this.onSelectCustomer.emit();
    };
    UserMenuComponent.prototype.toggleUserMenu = function () {
        this.showUserMenu = !this.showUserMenu;
    };
    return UserMenuComponent;
}());
export { UserMenuComponent };
